<div
  class="flex flex-col gap-4 rounded-lg border border-solid border-slate-200 bg-white p-4 shadow-sm"
>
  <div class="flex items-start justify-between">
    <div class="flex items-center gap-3">
      <mat-icon class="text-slate-400">history</mat-icon>
      <div class="flex flex-col gap-0.5">
        <span class="text-base font-bold">Viewing History</span>
        <span class="text-sm text-slate-500">
          Run on
          {{ run().runAt | moment | amDateFormat: dateTimeFormat }}
          <span class="text-slate-400"
            >&middot; {{ run().runAt | fromNow$ | async }}</span
          >
          @if (run() | map: isComplete) {
            <span class="text-slate-400">
              &middot; {{ run().result?.resultCount ?? 0 }} results
            </span>
          }
        </span>
      </div>
    </div>

    @if (run().pinned) {
      <span
        class="bg-primary-50 text-primary-700 inline-flex items-center gap-0.5 rounded-full px-2 py-0.5 text-[10px] font-medium"
      >
        <mat-icon class="icon-xs">push_pin</mat-icon>
        Pinned
      </span>
    } @else if (run().expiresAt) {
      <span
        class="inline-flex items-center rounded-full bg-amber-50 px-2 py-0.5 text-[10px] font-medium text-amber-700"
      >
        @if (isExpiringSoon()) {
          Expiring soon
        } @else {
          @if (run().expiresAt; as runExpiresAt) {
            Expires {{ runExpiresAt | moment | amDateFormat: dateFormat }}
          }
        }
      </span>
    }
  </div>

  <div
    class="flex items-center gap-2 border-t border-solid border-slate-100 pt-3"
  >
    <button mat-stroked-button (click)="backToCurrentReport.emit()">
      <mat-icon>arrow_back</mat-icon>
      Back to Current Report
    </button>

    <button
      mat-stroked-button
      [matTooltip]="runPinnedTooltip()"
      (click)="togglePin.emit()"
    >
      <mat-icon [ngClass]="{ 'text-primary-500': run().pinned }">
        push_pin
      </mat-icon>
      {{ run().pinned ? 'Unpin' : 'Pin' }}
    </button>

    @if (!run().pinned) {
      <button
        mat-stroked-button
        color="warn"
        matTooltip="Delete this run and return to the current report"
        (click)="archive.emit()"
      >
        <mat-icon>delete</mat-icon>
        Delete
      </button>
    }
  </div>
</div>
